// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const params = {
  requestId: __t.u128(),
  sourceUrl: __t.string(),
  targetModule: __t.string(),
  format: __t.string(),
  scope: __t.string(),
  converter: __t.option(__t.string()),
  assetId: __t.u64(),
  sourceRenditionId: __t.u64(),
  operation: __t.string(),
  lodSpec: __t.string(),
  geoOrigin: __t.string(),
};
export const returnType = __t.string()